import axios from 'axios';
import { logout, getToken } from '../Utils/authUtils';
import { toast } from 'react-toastify';

const axiosInstance = axios.create({

    // baseURL: 'http://13.232.134.145:5007/admin/',
    // baseURL: 'http://44.196.108.80:5007/admin',
    baseURL: 'https://resumate.org/backend/admin',

    timeout: 100000,
});

axiosInstance.interceptors.request.use(
    function (config) {
        const token = getToken();
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

const localVersion = localStorage.getItem('frontend_version');
axiosInstance.interceptors.response.use(
    function (response) {
        localStorage.setItem('frontend_version', response.headers.get('frontend_version'))
        if (localVersion === response?.headers?.frontend_version) {
            return response;
        } else if (localVersion == null || localVersion == undefined || localVersion == 'undefined' || localVersion == 'null') {
            return response;
        } else {
            localStorage.clear();
            window.location.href = '/';

        }
    },
    function (error) {
        if (error?.response?.status === 401) {

            const errorMessage = error?.response?.data?.message || '';
            if (errorMessage.includes('Invalid token') || errorMessage.includes('Unauthorized')) {

                logout("Session expired. Please login again.");
            } else {

                toast.error(errorMessage || "Authentication failed");
            }
        }
        // else{
        //     toast.error(error?.response?.data?.message)
        // }
        return error?.response;
    }
);
export default axiosInstance;